import React, {useRef} from 'react';
import SvgLink from '../SVG';
import {ICON_DOWN_ARROW} from '../SVG/consts';

function FiltersToggle({heading, children}) {
    const section = useRef(null);
    const filtersHeadingClassName = 'toggle-section-heading';
    return(
        <>
            <button className={`${filtersHeadingClassName} open`} onClick={(e) => {
                section.current.style.display = section.current.style.display === 'none' ? 'block' : 'none';
                e.currentTarget.className = e.currentTarget.className === filtersHeadingClassName ? `${filtersHeadingClassName} open` : filtersHeadingClassName;
            }}>{heading} <SvgLink {...ICON_DOWN_ARROW}/></button>
            <div ref={section} className="toggle-section filters-section">
                {children}
            </div>
        </>
    )
}

export default FiltersToggle;